var path = '/client/common/modules/no-results/views/no-results.html';
var html = "<div class=\"no-results\" ng-class=\"::vm.classes\">\n    <i class=\"mdi mdi-information-outline\"></i>\n    <span>{{ ::vm.text }}</span>\n</div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;